import React, { ComponentProps } from 'react';

export default function BackButtonIcon(props: ComponentProps<"svg">) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none" {...props}>
      <path opacity="0.4" d="M15 30C6.7275 30 0 23.271 0 15C0 6.729 6.7275 0 15 0C23.271 0 30 6.729 30 15C30 23.271 23.271 30 15 30Z" fill="#C7C7C7" fillOpacity="0.5"/>
      <path d="M17.1611 21.3311C16.8746 21.3311 16.5866 21.2216 16.3676 21.0026L11.1371 15.7976C10.9256 15.5861 10.8071 15.2996 10.8071 14.9996C10.8071 14.7011 10.9256 14.4146 11.1371 14.2031L16.3676 8.99512C16.8071 8.55712 17.5181 8.55712 17.9576 8.99812C18.3956 9.43912 18.3941 10.1516 17.9546 10.5896L13.5251 14.9996L17.9546 19.4096C18.3941 19.8476 18.3956 20.5586 17.9576 20.9996C17.7386 21.2216 17.4491 21.3311 17.1611 21.3311Z" fill={props.fill || 'black'}/>
    </svg>
  );
}
